import { useModal } from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import { SubmitButton } from "@/components/Global/Button/Button";
import { FormErrorState, Input } from "@/components/Global/Input/Input";
import { Section } from "@/components/Global/Section/Section";
import { Loader } from "@/components/Loader/Loader";
import { useAppContext } from "@/context/AppContext";
import { safeParseSchema, passwordResetSchema } from "@/utils/validations";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { useRouter } from "next/router";
import React, { FormEvent, useState } from "react";
import { confirmPasswordReset } from "@/utils/serviceAPI/password";

type PasswordResetDataType = {
  password: string;
  repeat: string;
};

function PasswordReset() {
  const { getLabel } = useGlobalContext();
  const { setFormModalText } = useAppContext();
  const [loading, setLoading] = React.useState(false);
  const router = useRouter();
  const token = router.query?.token as string;
  const { setOpen } = useModal();

  const validationMessages = {
    required_field: getLabel("error_required_field"),
    passwords_not_matching: getLabel("passwords_not_matching"),
  };
  const [errors, setErrors] = useState<FormErrorState>();

  /* jscpd:ignore-start */
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const formProps = Object.fromEntries(formData);
    const { data, flattenedErrors } = safeParseSchema(
      passwordResetSchema(validationMessages),
      formProps,
    );

    if (data) {
      setLoading(true);
      setErrors({});
      try {
        const { password } = data as PasswordResetDataType;
        const res = await confirmPasswordReset(password, token);
        if (res) {
          setOpen(true);
          setLoading(false);
          setFormModalText(getLabel("password_reset_modal_success"));
        } else {
          setOpen(true);
          setLoading(false);
          setFormModalText(getLabel("password_reset_modal_failed"));
        }
      } catch (err) {
        console.error("Password reset failed:", err);
      }
    } else {
      setErrors(flattenedErrors);
    }
  };
  /* jscpd:ignore-end */

  return (
    <Section columnsClassName="is-centered is-multiline">
      <div className="column is-10-tablet is-8-desktop is-6-widescreen">
        {/* jscpd:ignore-start  */}
        <form onSubmit={handleSubmit} autoComplete="on">
          <Input
            inputType="password"
            id="password"
            name="password"
            label={getLabel("login_form_label_password")}
            placeholder={getLabel("login_form_placeholder_password_set")}
            errors={errors}
            aria-autocomplete="list"
          ></Input>
          <Input
            inputType="password"
            id="repeat"
            name="repeat"
            label={getLabel("login_form_label_password_repeat")}
            placeholder={getLabel("login_form_placeholder_password_repeat")}
            errors={errors}
            aria-autocomplete="list"
            className="mb-5"
          ></Input>

          <SubmitButton className="login-submit-buton">
            {getLabel("password_reset")}
          </SubmitButton>

          {loading && <Loader />}
        </form>
        {/* jscpd:ignore-end  */}
      </div>
    </Section>
  );
}

export default PasswordReset;
